<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>

      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="cardType === 'AssignedCards'"
          :label="$t('Download Template')"
          size="md"
          @click="onDownloadTemplate"
        />
      </div>
    </div>

    <b-row class="match-height mt-1 mb-4">
      <b-col
        :md="12"
      >
        <div>
          <validation-observer ref="batchCardsRequestRules">
            <b-form @submit.prevent="handleSubmit">
              <b-row class="match-height">
                <!-- Card Request Type -->
                <b-col md="6">
                  <SelectField
                    id="card-request-type"
                    v-model="batchCardRequestFormData.cardRequestType"
                    :label="$t('Card Request Type')"
                    :placeholder="$t('Select')"
                    :options="translatedCardRequestOptions"
                    item="label"
                    :reduce="option => option.value"
                    :error-name="$t('Card Request Type')"
                    rules="required"
                    :set-selected="setCardRequestType"
                  />
                </b-col>
                <!-- Card Request Type -->

                <!-- Card Profile -->
                <b-col md="6">
                  <SelectField
                    id="host-financial-institution"
                    v-model="batchCardRequestFormData.cardProfileId"
                    :label="$t('Card Profile')"
                    :placeholder="$t('Select')"
                    :options="cardProfileList"
                    item="label"
                    :reduce="option => option.value"
                    :loading="isLoadingCardProfile"
                    :error-name="$t('Card Profile')"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Card Profile -->
                <!-- Card Type -->
                <b-col md="6">
                  <SelectField
                    id="card-type"
                    v-model="batchCardRequestFormData.cardType"
                    :label="$t('Card Type')"
                    :placeholder="$t('Select')"
                    :options="translatedCardTypeOptions"
                    item="label"
                    :reduce="option => option.value"
                    :error-name="$t('Card Type')"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Card Type -->

                <!-- Number-of-cards -->
                <b-col
                  v-if="cardType === 'UnassignedCards'"
                  md="6"
                >
                  <InputField
                    id="number-of-cards"
                    v-model.number="batchCardRequestFormData.numberOfCards"
                    :label="$t('How Many Card?')"
                    type="number"
                    rules="required|positive"
                    :error-name="$t('Number of cards')"
                    :is-allow-negative-numbers="false"
                    onpaste="return false;"
                  />
                </b-col>
                <!-- Number-of-cards -->
              </b-row>
              <b-row
                v-if="cardType === 'AssignedCards'"
              >

                <!-- Select Card Request File -->
                <b-col
                  md="5"
                  class="mt-1"
                >
                  <b-form-file
                    id="file-name"
                    v-model="hasFileData"
                    :label="$t('Select File (.xlsx format only)')"
                    :state="Boolean(hasFileData)"
                    :placeholder="$t('Select Card Request File (.xlsx format only)')"
                    :drop-placeholder="$t('Drop file here...')"
                    error-name="file"
                    rules="required"
                    accept=".xlsx"
                    @change="onChangeXLSX($event)"
                  />
                  <p
                    v-if="totalRecordsUploaded"
                    class="pt-1"
                    style="font-size: 14px;"
                  >
                    {{ $t('There are total of') }} ({{ totalRecordsUploaded }}) {{ $t('records fetched') }}
                  </p>
                </b-col>
                <!-- Select Card Request File -->
                <b-col
                  md="2"
                  class="mt-1"
                >
                  <Button
                    :label="$t('Preview')"
                    :loading="isLoadingPreview"
                    :disabled="isDisablePreview"
                    variant="primary"
                    size="md"
                    @click="onPreview"
                  />
                </b-col>
              </b-row>
              <div
                v-if="cardType === 'UnassignedCards'"
                class="text-center mt-5"
              >
                <Button
                  :label="$t('Make Request')"
                  :loading="isLoading"
                  :disabled="isDisabled"
                  variant="primary"
                  size="lg"
                  @click="handleSubmit"
                />
              </div>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="preview-modal"
      ref="previewCustomerModal"
      :ok-title="$t('Upload')"
      no-close-on-backdrop
      :ok-disabled="isUploadingCustomerList"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Preview Customer List')"
      @ok="handleUpload"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <TableEntries
              v-model="perPage"
              :options="perPageOptions"
            />

          </b-col>

          <!-- Export -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                text="Export"
                variant="primary"
              >
                <b-dropdown-item @click="excelExport(exportableData)">
                  {{ $t('Excel') }}
                </b-dropdown-item>
                <!-- <b-dropdown-item @click="pdfExport(exportableData)">
                  PDF
                </b-dropdown-item>
                <b-dropdown-item onclick="window.print()">
                  PRINT
                </b-dropdown-item> -->
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="previewTableRef"
        :per-page="perPage"
        :current-page="currentPage"
        :items="customerList"
        responsive
        :fields="tableHeaders"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
        <template #cell(accountStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />
      <template
        #modal-footer="{ }"
      />
      <FullScreenSpinner :show="showSpinner" />
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BForm, BFormFile, BTable, BModal, BDropdown, BDropdownItem, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, positive } from '@validations'
import { heightFade } from '@core/directives/animations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import { cardRequestOptions } from '@/helpers/data'
import { eChannelsPermission } from '@/helpers/permissions'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import getStatusColor from '@/helpers/getStatusColor'
import { downloadTemplate } from '@/helpers/constants'

const cardTypeOptions = [
  { label: 'Default', value: 1 },
  { label: 'VirtualUSSD', value: 2 },
]

export default {
  components: {
    BCard,
    BRow,
    BTable,
    BBadge,
    BModal,
    BDropdown,
    BDropdownItem,
    BCol,
    Button,
    BForm,
    BFormFile,
    ValidationObserver,
    TablePagination,
    TableEntries,
    InputField,
    SelectField,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert],
  data() {
    return {
      getStatusColor,
      isLoadingPreview: false,
      isUploadingCustomerList: false,
      isDisablePreview: true,
      isLoadingCardProfile: false,
      isFlatAmountRequired: '',
      isPercentageRequired: '',
      isLoading: false,
      isDisabled: false,
      cardType: '',
      totalRecordsUploaded: '',
      positive,
      sortBy: 'accountName',
      showSpinner: false,
      required,
      // cardRequestOptions,
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', sortable: true, label: 'account number' },
        { key: 'accountName', sortable: true, label: 'account name' },
        { key: 'productName', sortable: true, label: 'product' },
        { key: 'accountStatus', sortable: true, label: 'account status' },
        { key: 'remark', sortable: true, label: 'remark' },
      ],
      batchCardRequestFormData: {
        cardRequestType: '',
        cardProfileId: '',
        numberOfCards: '',
        cardType: '',
      },
      hasFileData: [],
      cardProfileList: [],
      customerList: [],
      fileData: [],
      parseExcelFile: [],
      customerAccountNumbers: [],
      // cardTypeOptions: [
      //   { label: 'Default', value: 1 },
      //   { label: 'VirtualUSSD', value: 2 },
      // ],
      perPage: 50,
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
    }),
    exportableData() {
      return this.customerList.map((item, index) => ({
        'S/N': index + 1,
        'Account Number': item.accountNumber,
        'Account Name': item.accountName,
        Product: item.productName,
        'Account Status': item.accountStatus,
        Remark: item.remark,
      }))
    },
    translatedCardRequestOptions() {
      return cardRequestOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedCardTypeOptions() {
      return cardTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  mounted() {
    this.fetchCardProfiles()
  },
  methods: {
    ...mapActions({
      getCardProfileList: 'eChannels/getCardProfileList',
      requestUnAssignedCards: 'eChannels/requestUnAssignedCardsAction',
      requestAssignedCards: 'eChannels/requestAssignedCardsAction',
      getAssignedCardsByAccountNumbers: 'eChannels/getAssignedCardsByAccountNumbers',
      downloadAccountFormat: 'batch/downloadAccountFormat',
    }),
    async onDownloadTemplate() {
      try {
        const { status, data } = await this.downloadAccountFormat(downloadTemplate.assignedCardRequestCode)
        if (status === 200) {
          const downloadAnchor = document.createElement('a')
          downloadAnchor.setAttribute('href', data.data)
          const filename = 'Udara360-Batch-Assigned-Cards.xlsx'
          downloadAnchor.setAttribute('download', filename)
          document.body.appendChild(downloadAnchor)
          downloadAnchor.click()
          document.body.removeChild(downloadAnchor)
          // this.alertSuccess({ text: 'Your request to download Batch Assigned Cards Format was successful' })
        }
      } catch (error) {
        const reasonText = this.$t('Your request to download Batch Assigned Cards Format failed. Reason')
        this.alertError({ text: `${reasonText}: ${this.readError(error)}` })
      } finally {
        this.isLoading2 = false
        this.isDisabled2 = false
      }
    },
    setCardRequestType(value) {
      if (value === 'AssignedCards') {
        this.isDisabled = true
        // eslint-disable-next-line no-return-assign
        return this.cardType = 'AssignedCards'
      }

      this.batchCardRequestFormData.numberOfCards = ''
      this.isDisabled = false
      // eslint-disable-next-line no-return-assign
      return this.cardType = 'UnassignedCards'
    },
    async fetchCardProfiles() {
      try {
        this.isLoadingCardProfile = true
        const { status, data } = await this.getCardProfileList({
          search: {},
          page: 1,
          limit: 200,
          permission: eChannelsPermission.REQUEST_ASSIGNED_CARDS,
        })

        if (status === 200 && data.data) {
          this.cardProfileList = data.data.filter(item => item.status.toLowerCase() === 'active').map(item => ({ label: item.name, value: item.id }))
        } else {
          this.hostFinancialInstitutionList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingCardProfile = false
      }
    },
    async cardRequestAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const label = this.cardType === 'UnassignedCards' ? this.$t('Unassigned cards') : this.$t('Assigned cards')
        if (this.cardType === 'UnassignedCards') {
          const { status } = await this.requestUnAssignedCards({
            cardProfileId: this.batchCardRequestFormData.cardProfileId,
            numberOfCards: this.batchCardRequestFormData.numberOfCards,
            cardType: this.batchCardRequestFormData.cardType,
          })

          if (status === 200) {
            const text1 = this.$t('Your batch request for')
            const text2 = this.$t('was successful')
            this.alertSuccess({ text: `${text1} ${label} ${text2}` })
            this.resetFormData()
            this.$router.push({ name: 'batch-cards-request-list' })
          }
        }
      } catch (error) {
        this.handleError(error)
        this.isLoading = false
        this.isDisabled = false
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    onChangeXLSX(event) {
      this.fileData = event.target.files ? event.target.files[0] : null
      if (this.fileData) {
        const vm = this
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'binary', cellDates: true, dateNF: 'mm/dd/yyyy;@' })
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const rowObject = XLSX.utils.sheet_to_row_object_array(worksheet, { raw: false })
          const arrayList = [...new Map(rowObject.map(v => [v.AccountNo, v])).values()] // remove duplicates account numbers

          vm.totalRecordsUploaded = arrayList.length
          vm.totalCount = arrayList.length
          vm.parseExcelFile = JSON.parse(JSON.stringify(rowObject)).forEach(items => {
            vm.customerAccountNumbers.push(items.AccountNo)
          })
        }
        this.isDisablePreview = false
        reader.readAsBinaryString(this.fileData)
      }
    },
    handleSubmit() {
      this.$refs.batchCardsRequestRules.validate().then(async success => {
        if (success) {
          const label = this.cardType === 'UnassignedCards' ? this.$t('Unassigned cards') : this.$t('Assigned cards')
          const areYouSure = this.$t('Are you sure you want to request')
          this.confirm(this.cardRequestAction, { text: `${areYouSure} ${label}?` })
        }
      })
    },
    handleUpload(bvModalEvt) {
      bvModalEvt.preventDefault()
      const requestAssignedCard = async () => {
        try {
          this.showSpinner = true
          const formData = {
            cardProfileId: this.batchCardRequestFormData.cardProfileId,
            accounts: this.customerAccountNumbers,
            cardType: this.batchCardRequestFormData.cardType,
          }
          const { status, data } = await this.requestAssignedCards(formData)
          if (status === 200 && data.successResponse) {
            this.alertSuccess({ text: this.$t('Your batch request for assigned cards was successful') })
            this.resetFormData()
            this.$router.push({ name: 'batch-cards-request-list' })
            this.showSpinner = false
          }
          if (status === 200 && data.failedValidations) {
            const transformData = data.failedValidations.reduce((memo, curr) => {
              const res = Object.entries(curr).map(([key, value]) => `${key} - ${value}`)
              return [...memo, ...res]
            }, [])
            if (transformData.length !== 0) {
              const text = transformData.map(item => (
                `<p>${item}</p>`
              )).join('')
              this.alertError({ html: text })
              this.showSpinner = false
            }
          }
        } catch (error) {
          this.handleError(error)
          this.showSpinner = false
        }
      }
      this.confirm(requestAssignedCard, { text: this.$t('Are you sure you want to upload these customer list?') })
    },
    async onPreview() {
      this.$refs.batchCardsRequestRules.validate().then(async success => {
        if (success) {
          try {
            this.showSpinner = true
            const accountNumber = this.customerAccountNumbers.map(item => ({
              accountNumber: item,
            }))
            const formData = {
              cardProfileId: this.batchCardRequestFormData.cardProfileId,
              accounts: accountNumber,
              cardType: this.batchCardRequestFormData.cardType,
            }

            const { status, data } = await this.getAssignedCardsByAccountNumbers({
              formData,
              permission: eChannelsPermission.REQUEST_ASSIGNED_CARDS,
            })
            if (status === 200) {
              this.customerList = data.validationResult.map(item => ({
                accountName: item.accountName,
                accountStatus: item.accountStatus,
                productName: item.productName,
                accountNumber: item.accountNumber,
                remark: item.remark,
              }))
              this.$root.$emit('bv::show::modal', 'preview-modal')
              this.showSpinner = false
            }
          } catch (error) {
            this.showSpinner = false
            this.handleError(error)
          } finally {
            this.showSpinner = false
          }
        }
      })
    },
    excelExport(data) {
      this.isDisabled = false
      const arrData = data

      const filename = 'Assigned Card Request List.xlsx'
      const headerLists = [
        Object.keys(arrData[0]),
      ]
      const Heading = []
      const Data = arrData // All data lists
      const ws = XLSX.utils.aoa_to_sheet(Heading)

      XLSX.utils.sheet_add_aoa(ws, headerLists, { origin: 'A14' })

      XLSX.utils.sheet_add_json(ws, Data, {
        skipHeader: true,
        origin: 'A15',
      })

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Assigned Card Request')
      XLSX.writeFile(wb, filename)
    },
    resetFormData() {
      this.batchCardRequestFormData = { ...null }
      this.customerList = []
      this.cardType = ''
      this.totalRecordsUploaded = ''
      this.hideModal('preview-modal')
    },
    backNavigationAction() {
      this.$router.push({
        name: 'batch-cards-request-list',
      })
    },
  },
}
</script>
  <style scoped>
  .card-item {
    border: 1px solid #d8d6de !important;
    border-radius: 0.358rem
  }
  </style>
